import { HttpErrorResponse } from "@angular/common/http";
import { Subscription } from "rxjs";

import { EvidenciaPrueba } from "./etapas-versiones.model";
import { EtapasVersionesService } from "./etapas-versiones.service";
import { nombreDeEvidencia } from "./pruebas-version.util";

/*
 * «Ver evidencia» de una ejecución de pruebas (A2 y la edición de T2):
 * PROYECTOS_PRUEBAS_EVIDENCIA responde el archivo como adjunto, así que se
 * pide como blob con el interceptor normal (para que viaje el token; un
 * window.open no lo lleva) y se baja con el nombre con que se subió. Los
 * rechazos llegan en el estado HTTP, sin cuerpo (EtapasVersionesService del
 * servidor): 400, 403, 404 o 500.
 */

/** Pide la evidencia y la baja; si no se puede, avisar recibe el motivo. */
export function descargarEvidencia(
  servicio: EtapasVersionesService,
  idEjecucion: string,
  evidencia: Pick<EvidenciaPrueba, "archivo" | "nombreOriginal">,
  avisar: (texto: string) => void,
): Subscription {
  return servicio.evidencia(idEjecucion, evidencia.archivo).subscribe({
    next: (respuesta) => {
      if (respuesta.body) {
        guardarArchivo(respuesta.body, nombreDeEvidencia(evidencia));
      } else {
        avisar("La evidencia llegó vacía. Intenta de nuevo.");
      }
    },
    error: (error: unknown) => avisar(motivoDeEvidencia(error)),
  });
}

/** Lo que se le dice a la persona cuando la evidencia no baja, por el estado HTTP. */
export function motivoDeEvidencia(error: unknown): string {
  const estado = error instanceof HttpErrorResponse ? error.status : 0;
  switch (estado) {
    case 0:
      return "No se pudo bajar la evidencia: sin conexión con el servidor.";
    case 403:
      return "No tienes permiso para ver la evidencia de este proyecto.";
    case 404:
      return "La evidencia ya no está disponible.";
    default:
      return "No se pudo bajar la evidencia. Intenta de nuevo.";
  }
}

function guardarArchivo(blob: Blob, nombre: string): void {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = nombre;
  enlace.rel = "noopener";
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
